import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { getNextMonth, getPrevMonth } from '../../../common/helper/commonHelper.js';

class Calendar extends Component {
    constructor(props) {
        super(props);

        this.refCalendar = React.createRef();
        this.state = {
            currentDate: new Date(),
        }
    }

    getCalendarRect() {
        const element = this.refCalendar.current;
        const rect = {
            top: element.clientTop,
            left: element.clientLeft,
            width: element.clientWidth,
            height: element.clientHeight,
        }
        return rect;
    }

    onClickDate(e, date) {
        const year = this.state.currentDate.getFullYear();
        const month = this.state.currentDate.getMonth() + 1;
        const cMonth = ('0' + month).slice(-2);
        const cDate = ('0' + date).slice(-2);

        if(this.props.onClickDate) {
            this.props.onClickDate(year + "-" + cMonth + "-" + cDate, this.props.target);
        }
    }
    onClose = (e) => {
        if(this.props.onClose) {
            this.props.onClose(this.props.target);
        }
    }

    createCalendar() {
        const weeks = ['日', '月', '火', '水', '木', '金', '土'];
        const year = this.state.currentDate.getFullYear();
        const month = this.state.currentDate.getMonth() + 1;
        const startDate = new Date(year, month - 1, 1);
        const endDate = new Date(year, month, 0);
        const startDay = startDate.getDay();
        const endDayCount = endDate.getDate();
        let dayCount = 1;

        let retTR = [];
        let retTD = [];
        for (let i = 0; i < weeks.length; i++) {
            let color = "#888888";
            if (i === 0) color = "#cc0000";
            if (i === 6) color = "#0000cc";
            retTD.push(
                <Data key={weeks[i]} Color={color}>
                    {weeks[i]}
                </Data>
            );
        }
        retTR.push(
            <Row key="week">
                {retTD}
            </Row>
        );

        for (let w = 0; w < 6; w++) {
            retTD = [];
            for (let d = 0; d < 7; d++) {
                if (w === 0 && d < startDay) {
                    retTD.push(
                        <Data key={"a" + d}></Data>
                    );
                } else if (dayCount > endDayCount) {
                    retTD.push(
                        <Data key={"b" + d}></Data>
                    );
                } else {
                    let color = "#888888";
                    let hover = "#eeeeee";
                    if (d === 0) {
                        color = "#cc0000";
                        hover = "#ffdddd";
                    } 
                    if (d === 6) {
                        color = "#0000cc"; 
                        hover = "#ddddff";
                    }
                    let date = dayCount;
                    retTD.push(
                        <Data key={dayCount} 
                            Color={color} Hover={hover}
                            onClick={e => this.onClickDate(e, date)}>
                            {dayCount}
                        </Data>
                    );
                    dayCount++;
                }
            }
            retTR.push(
                <Row key={"week" + w}>
                    {retTD}
                </Row>
            );
        }
        return (
            <Table>
                <TBody>
                    {retTR}
                </TBody>
            </Table>
        )
    }

    onClickDateBar = (e) => {
        let x = e.clientX - e.currentTarget.getBoundingClientRect().x;
        let width = e.currentTarget.getBoundingClientRect().width;
        if (x > (width / 2)) {
            let date = this.state.currentDate;
            date = getNextMonth(date);

            this.setState({ currentDate: date });
        } else {
            let date = this.state.currentDate;
            date = getPrevMonth(date);

            this.setState({ currentDate: date });
        }
    }

    render() {
        const year = this.state.currentDate.getFullYear();
        const month = this.state.currentDate.getMonth() + 1;
        return (
            <Body Display={this.props.display}>
                <Back Display={this.props.display} onClick={this.onClose}></Back>
                <Main name="calendar" id="calendar" ref={this.refCalendar} Display={this.props.display} Top={this.props.top} Left={this.props.left}>
                    <DateView onClick={this.onClickDateBar}>
                        <DateCtrl>
                            <i className="fas fa-chevron-left" />
                        </DateCtrl>
                        {year + " / " + month}
                        <DateCtrl>
                            <i className="fas fa-chevron-right" />
                        </DateCtrl>
                    </DateView>
                    {this.createCalendar()}
                </Main>
            </Body>
        );
    }
}

Calendar.propTypes = {
    top: PropTypes.string.isRequired,
    left: PropTypes.string.isRequired,
    display: PropTypes.bool.isRequired,
    onClickDate: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};

export { Calendar };

const Body = styled.div`
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    pointer-events: ${props => (props.Display ? '' : 'none')};
`;

const Back = styled.div`
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;
`;

const Main = styled.div`
    opacity: ${props => props.Display ? "1" : "0"};
    box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.2);
    color: #888;
    border-radius: 5px;
    background-color: #fff;
    padding: 5px;

    position: absolute;
    top: ${props => props.Top};
    left: ${props => props.Left};
`;
const Table = styled.table`
    border-collapse: collapse;
`;
const TBody = styled.tbody`
`;
const Row = styled.tr`
`;
const Data = styled.td`
    text-align: right;
    padding: 4px;
    color: ${props => props.Color};
    cursor: pointer;
    transition-duration: 0.2s;

    ${props => props.Hover ? css`
    :hover {
        background-color: ${props => props.Hover };
    }
    `:css``};
`;

const DateView = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;

    color: #888;
    width: calc(100% - 10px);
    padding: 2px 5px;
`;
const DateCtrl = styled.div`
    padding: 0 5px;
    cursor: pointer;
`;
